import conciergeLogo from '@client/pages/public/enroll/assets/concierge-horizontal.png';
import {POSTHOG_UNMASK_CLASS} from '@common-web/lib/analytics';
import {useEnrollGroup} from '@client/pages/public/enroll/enrollContext';

export function Footer() {
  const group = useEnrollGroup();
  const phoneDigits = group.supportPhone.replace(/[^\d]/g, '');

  return (
    <footer className={`mt-16 border-t border-neutral-200 bg-card ${POSTHOG_UNMASK_CLASS}`}>
      <div className='mx-auto grid max-w-7xl gap-6 px-6 py-10 text-sm text-neutral-500 md:grid-cols-4'>
        <div className='md:col-span-2'>
          <img
            src={conciergeLogo}
            alt='Concierge Third Party Administrator'
            width={494}
            height={96}
            className='mb-3 h-10 w-auto'
          />
          <p className='mb-1 font-semibold text-neutral-700'>
            Benefit Plans Rooted in Flexibility, Affordability, and Excellent Service.
          </p>
          <p className='italic text-neutral-500'>That's the Concierge Promise.</p>
          <p className='mt-3 text-xs text-neutral-400'>
            A Workhorse TPA since 2014. HCAA · SIIA · SPBA member.
          </p>
        </div>

        <div>
          <div className='mb-2 font-semibold text-neutral-700'>Concierge Team</div>
          <p>
            Questions about your benefits?{' '}
            <a
              href={`tel:${phoneDigits}`}
              className='font-semibold hover:underline'
              style={{color: 'var(--enroll-primary)'}}
            >
              {group.supportPhone}
            </a>
          </p>
          <p className='mt-2 text-xs'>
            Bartlesville, OK · Oklahoma City, OK
            <br />
            <a
              href='https://ctpa.com'
              target='_blank'
              rel='noreferrer'
              className='hover:underline'
              style={{color: 'var(--enroll-primary)'}}
            >
              ctpa.com
            </a>
          </p>
        </div>

        <div>
          <div className='mb-2 font-semibold text-neutral-700'>Required Notices</div>
          <p className='text-xs'>
            COBRA continuation, CHIPRA premium-assistance, and Medicare Part D creditable-coverage
            notices are available from your {group.benefitsContact ?? 'HR department'}. The prescription drug coverage offered
            through these Plans is <span className='font-semibold'>non-creditable</span> relative to
            Medicare Part D.
          </p>
        </div>
      </div>

      <div className='border-t border-neutral-200 py-4'>
        <div className='mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-6 text-xs text-neutral-400'>
          <div>© {new Date().getFullYear()} Concierge Third Party Administrator. All rights reserved.</div>
          <div>
            Coverage details are governed by the Plan Document. If there is a discrepancy, the Plan
            Document is the authority.
          </div>
        </div>
      </div>
    </footer>
  );
}
